export default __webpack_public_path__ + "static/media/higherlife.87eeec61.png";